export default "__VITE_ASSET__C2AJ1M9T__"